import { ENABLE_LOGGING } from "../../_game/config/Game";
import ProxiAbstract from "./Proxi.Abstract";

interface ProxiProviderInterface {
  isRealityCheck: boolean;
  isRoundRunning: boolean;
  isNoWrapper: boolean;
}

export default class ProxiProvider implements ProxiAbstract {
  public name: string;
  protected state: ProxiProviderInterface;

  constructor() {
    this.name = "PROXI PROVIDER";
    this.state = {
      isRealityCheck: false,
      isRoundRunning: false,
      // isNoWrapper: __UrlParams.props.noWrapper === "true",
      isNoWrapper: false,
    };
  }

  /** Static functions */
  initialize(sessionID?: string | number) {
    this.log("Initialize");
    return true;
  }

  gameReady() {
    this.log("Game ready ");
  }

  gameExit() {
    this.log("Player exit ");
  }

  serverInitComplete() {
    this.log("Server init ");
  }

  visitLobby() {
    this.log("Visit Lobby");
  }

  visitCashier() {
    //visit deposit
    this.log("Visit Cashier");
  }

  visitHistory() {
    //visit account page
    this.log("Visit History");
  }

  visitRules() {
    //visit rules page
    this.log("Visit Rules");
  }

  roundStart(_bet: number, _credit: number): void {
    this.log(`Round Start with bet: ${_bet} and credit ${_credit}`);
  }

  toggleWrapperActive(_boolean: boolean) {
    this.state.isNoWrapper = _boolean;
    this.log("Wrapper activity is now " + _boolean + " ");
  }

  toggleRealityCheck(_boolean: boolean) {
    if (this.state.isRealityCheck !== _boolean) {
      this.state.isRealityCheck = _boolean;
      this.log("Reality Check is now " + _boolean + " ");
    }
  }

  sendRoundOn(_boolean: boolean): void {
    this.log(" Round running is now " + _boolean + " ");
  }

  toggleSound(_boolean: boolean): void {
    this.log("Global sound is now " + _boolean + " ");
  }

  updateLoadingProgress(_percent: number): void {
    this.log("Loading progress " + _percent + "% ");
  }

  updateWinnings(_number: number): void {
    this.log("Player wins " + _number);
  }

  updateStake(_number: number): void {
    this.log("Player set Stake to " + _number);
  }

  updateBalance(_number: number, _stake: number): void {
    this.log("Player balance:" + _number);
  }

  sendWindowSize(_width: number, _height: number) {
    this.log("Window size:" + _width + "x" + _height);
  }

  roundStarted(_obj: any) {
    this.log("Round started : " + JSON.stringify(_obj));
  }

  roundEnded(obj: any) {
    this.log("Round Ended");
  }

  gameLoadingStarted() {
    this.log("Game Loading Started");
  }

  paytableDialogueOpened() {
    this.log("Play Table Dialogue Opened");
  }

  paytableDialogueClosed() {
    this.log("Play Table Dialogue Closed");
  }

  insufficientFunds() {
    this.log("Insufficient Funds");
  }

  gameLoadingEnded() {
    this.log("Game loading Ended");
  }

  rulesDialogueOpened() {
    this.log("Rules Dialogue Opened");
  }

  rulesDialogueClosed() {
    this.log("Rules Dialogue Closed");
  }

  gotoAccountsPage() {
    this.log("Go to Account Page");
  }

  gotoResponsibleGamingPage() {
    this.log("Go to Responsible Gaming Page");
  }

  menuDialogOpened() {
    this.log("Menu Dialog Opened");
  }

  menuDialogClosed() {
    this.log("Menu Dialog Closed");
  }

  betDialogueOpened() {
    this.log("Bet Dialogue Opened");
  }

  betDialogueClosed() {
    this.log("Bet Dialogue CLosed");
  }

  autospinDialogueOpened() {
    this.log("Autospin Dialogue Opened");
  }

  autospinDialogueClosed() {
    this.log("Autospin Dialogue Closed");
  }

  getScreenSize(_width: number, _height: number) {
    this.log("Get Screen Size");
  }

  gameReload() {
    this.log("Game Reload");
  }

  log(data: any) {
    if (!ENABLE_LOGGING || this.state.isNoWrapper) return;
    console.groupCollapsed(
      "%c PROXI                                ",
      "background: #5d00ff; color: white; display: block;"
    );
    console.log(`${this.name}: ${data}`);
    console.groupEnd();
  }
}
